import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e2d568c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  width: "14",
  height: "10",
  viewBox: "0 0 14 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M1 5.49943L4.65259 9L13 1",
  stroke: "#2E5BFF",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AvatarOrInitials = _resolveComponent("AvatarOrInitials")!
  const _component_Typography = _resolveComponent("Typography")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["recipient-container", { compact: _ctx.compact }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pick', _ctx.recipient)))
  }, [
    _createVNode(_component_AvatarOrInitials, {
      user: _ctx.userForAvatar,
      size: 40
    }, null, 8, ["user"]),
    _createVNode(_component_Typography, {
      class: "name",
      variant: "body1"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.recipientName), 1)
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass({ checkbox: true, selected: _ctx.selected })
    }, [
      (_ctx.selected)
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}